import React from "react";
import { Box, makeStyles, MenuItem, TextField } from "@material-ui/core";


let useStyles = makeStyles((theme) => ({
    root: {
        width: "270px",
        height:50,
        margin:5,
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        [theme.breakpoints.down("950")]: {
            minWidth: '48%',
        },
        [theme.breakpoints.down("700")]: {
            width: '100%',
        },
    },
    box:{
        margin:0,
    }
}))

export default function Index({ state, handleChange }) {

    let classes = useStyles();

    return (
        <div className={classes['root']}>
            <Box
                className={classes['box']}
                width="100%"
                height="50px"
            >
                <TextField
                    id="standard-select-currency"
                    select
                    value={state?.settlement_type_id ? state?.settlement_type_id : ''}
                    onChange={(event) => handleChange(+event.target.value, "settlement_type_id")}
                    helperText=""
                    size="small"
                    fullWidth
                    variant="outlined"
                    label={'نوع تسویه'}
                >
                    <MenuItem value="1">نقدی</MenuItem>
                    <MenuItem value="2">اعتباری</MenuItem>
                    <MenuItem value="3">نقدی / اعتباری</MenuItem>
                    <MenuItem value="">همه</MenuItem>
                </TextField>
            </Box>
        </div>)
}
